import { REGEX_ADDRESS, REGEX_EMAIL, REGEX_EMAIL_LOCAL_INVALID_CONDITION, REGEX_NUMBERS, } from "../../const/regexes";
import { ADDRESS_LINE1_INVALID, EMAIL_INVALID, PHONE_INVALID, PHONE_LENGTH, ZIP_CODE_INVALID, ZIP_CODE_LENGTH, } from "../../schemas/const/errorMessages";
import onlyDigitsLength from "../onlyDigitsLength";
import { isNotAllSameDigit, isNotSequence } from "../phoneNumberRegex";
export var validatePhoneStruct = function (value) {
    return onlyDigitsLength(value) < 10 && onlyDigitsLength(value) > 0
        ? PHONE_LENGTH.message
        : (isNotAllSameDigit(value) && isNotSequence(value)) ||
            PHONE_INVALID.message;
};
export var validateZip = function (value) {
    return onlyDigitsLength(value) < 5
        ? ZIP_CODE_LENGTH.message
        : value !== "00000" || ZIP_CODE_INVALID.message;
};
export var validateAddress = function (value) {
    return ((!REGEX_NUMBERS.test(value) && REGEX_ADDRESS.test(value)) ||
        ADDRESS_LINE1_INVALID.message);
};
var isValidEmailLocal = function (local) {
    return !REGEX_EMAIL_LOCAL_INVALID_CONDITION.test(local) && (local === null || local === void 0 ? void 0 : local.length) <= 64;
};
var isValideEmailDomain = function (domain) {
    return domain === null || domain === void 0 ? void 0 : domain.split(".").every(function (segment) { return segment.length <= 63; });
};
export var validateEmail = function (email) {
    var _a = email.split("@"), local = _a[0], domain = _a[1];
    return ((email.length <= 254 &&
        isValidEmailLocal(local) &&
        isValideEmailDomain(domain) &&
        REGEX_EMAIL.test(email)) ||
        EMAIL_INVALID.message);
};
